<!--
 * @Author: LiZhiWei
 * @Date: 2026-06-01 16:24:50
 * @LastEditors: LiZhiWei
 * @LastEditTime: 2026-06-02 10:51:31
 * @Description: 
-->
<template>
  <div class="mb-48px max-w-760px lt-sm:mb-60px lt-sm:max-w-full lt-sm:px-0 mx-auto text-center">
    <h2
      class="pf-sc-semibold font-s-40px tracking-0 text-#0f172a lt-sm:break-words lt-sm:font-s-42px lt-sm:leading-[60px] m-0 leading-[60px]"
    >
      {{ title }}
    </h2>
    <p
      v-if="description"
      class="pf-sc-regular mt-16px font-s-16px text-#64748b lt-sm:max-w-full lt-sm:px-28px lt-sm:font-s-24px lt-sm:leading-[40px] mx-auto mb-0 leading-[30px] break-words"
    >
      {{ description }}
    </p>
  </div>
</template>

<script setup lang="ts">
  defineOptions({
    name: 'SectionHeading',
  })

  defineProps<{
    description?: string
    title: string
  }>()
</script>
